import axios from 'axios';
import store from '../store';

const defaultClient = axios.create({
	baseURL: `${process.env.VUE_APP_ROOT_API}/api`
});

defaultClient.interceptors.request.use(function (config) {
	store.dispatch("resetErrors");
	store.dispatch("resetWarnings");
	return config;
}, function (error) {
	return Promise.reject(error);
});

defaultClient.interceptors.response.use(
	async function (response) {
		await store.dispatch("setWarning", response);
		return response;
	},
	async function (error) {
		if (error.response.status === 401 || error.response.status === 403) {
			await store.dispatch("authentication/logoutFromApp");
		} else {
			await store.dispatch("setError", error.response);
			window.scrollTo(0, 0);
		}
		return Promise.reject(error);
	}
);

export function setAuthenticationHeaderAxios(token) {
	defaultClient.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : null;
}

export default defaultClient;
